import Http from '../Http'

export default {
	async all () {
		try {
			const response = await Http.get('api/subscriber/survey_sections') 
			return response.data
		} catch (err) {
			throw err
		}
	},
}
